<template>
	<!-- single是否显示头部导航 -->
	<div class="w100" v-if='!$route.meta.single'><!-- 显示头部导航 -->
		<Header :opacity="$route.meta.headerOpacity?$route.meta.headerOpacity:1" :title="$route.meta.title" :projectName="$route.meta.projectName"></Header>
		<div class="container">
			<!-- 登录前的 -->
			<router-view/>
		</div>
    	<Footer :bgColor="$route.meta.footerbg?$route.meta.footerbg:''" :fontColor="$route.meta.ftColor?$route.meta.ftColor:''"></Footer>
	</div>
	<!-- 不显示头部导航 -->
	<div class="w100" v-else>
		<router-view />
	</div>
</template>
<script>
import Header from '../../components/header'
import Footer from '../../components/footer'
export default {
	components:{
			Header,
			Footer,
	},
	data() {
		return {
			
		}
	},
	mounted() {
		this.getUserAgent();
		
    },
    
	methods: {
		
		getUserAgent() {
			if (navigator.userAgent.indexOf("MSIE 9.0")!=-1) {
				alert('为了给您提供更好的服务，建议您使用IE9以上浏览器进行访问');
			}
		},
		
		
	}
}
</script>

